import { LottiePlayer } from '../common/LottiePlayer';

export const Spinner = () => {
  return (
    <div className="flex w-full h-[100vh] items-center justify-center">
      <div className={'w-[50%] max-w-[72px] h-full'}>
        <LottiePlayer src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/lotties/common/ani_loader.json`} />
      </div>
    </div>
  );
};
